export const sportSearchAnalytics = {
  select: {
    eventName: 'sportTopFilter_search_click',
  },
  mobile_select: {
    eventName: 'sportTopFilter_searchMain_click',
  },
  search_btn_click: {
    click: {
      eventName: 'sportTopFilter_search_btn_click',
    },
  },
  sportTopFilter_searchClear_xIcon: {
    click: {
      eventName: 'sportTopFilter_searchClear_xIcon_click',
    },
  },
};
